<template>
    <app-layout :title="'Survey: ' + surveyModel.name" :survey-layout="true">
        <survey :preview="true" :surveyModel="surveyTemplate" :survey-responses="{}"/>
    </app-layout>
</template>

<script>
import Survey from "@/Components/Survey";
import AppLayout from "@/Layouts/AppLayout";
import {v4 as uuidv4} from 'uuid';
export default {
    name: "Show",
    components: {AppLayout, Survey},
    props: {
        surveyModel: {
            type: Object,
            required: true,
        }
    },
    setup(props) {
        const surveyTemplate = _.cloneDeep(props.surveyModel);

        surveyTemplate.sections.map((section) => {
            section.questions.map((question) => {
                question.answers.map((answer) => {
                    answer.id = uuidv4();
                    return answer;
                });
                question.id = uuidv4();
                return question;
            });
            section.id = uuidv4();
            return section;
        });

        return {
            surveyTemplate,
        }
    },
}
</script>

<style scoped>

</style>
